<template>
  <div v-show="isActive" class="y-tab-pane">
    <slot />
  </div>
</template>

<script setup>
import {
  computed,
  getCurrentInstance,
  inject,
  onMounted,
  onUnmounted
} from "vue";

const props = defineProps({
  label: { type: String, required: true }
});

const registerTab = inject("registerTab");
const activeIndex = inject("activeIndex");
const registeredTabs = inject("registeredTabs");
const unregisterTab = inject("unregisterTab");

const instance = getCurrentInstance();

onMounted(() => {
  if (registerTab) {
    registerTab({
      label: props.label,
      uid: instance.uid,
      el: instance.vnode.el
    });
  }
});

onUnmounted(() => {
  if (unregisterTab) {
    unregisterTab(instance.uid);
  }
});

const isActive = computed(() => {
  const myIndex = registeredTabs.findIndex(t => t.uid === instance.uid);
  return myIndex !== -1 && myIndex === activeIndex.value;
});
</script>
